import { render, staticRenderFns } from "./textAreaField.vue?vue&type=template&id=57889c31&"
import script from "./textAreaField.vue?vue&type=script&lang=ts&"
export * from "./textAreaField.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports